import { useTranslation } from 'react-i18next';
import { DefaultCard } from '../../../Card/Card';
import UsageMetricCard from './UsageMetricCard';
import type { CustomerUsageOverview } from '../../../../Constants/VOSS/usageTypes';

interface CustomerUsageProps {
    usage: CustomerUsageOverview | null;
    isLoading: boolean;
}

const CustomerUsage = ({ usage, isLoading }: CustomerUsageProps) => {
    const { t } = useTranslation();
    const metrics = usage?.metrics ?? [];

    return (
        <DefaultCard title={t('vossusage.header')} isLoading={isLoading}>
            <div className="row">
                {metrics.map((metric) => (
                    <div key={metric.metricKey} className="col-lg-4 col-md-12 mb-16">
                        <UsageMetricCard metric={metric} />
                    </div>
                ))}
            </div>
        </DefaultCard>
    );
};

export default CustomerUsage;
